import { MarketInfoLabel } from "./utility"
import './MarketIndexInfo.css'
import { useTranslation } from "react-i18next"

function MarketIndexInfo({ marketInfo }: { marketInfo: any }) {
    const { t } = useTranslation()
    const lang = 'vi'
    const defaultTheme = 'dark'
    const info: any = marketInfo
    const nameFloor = info?.subName
    return (

        <div className={'chart-info'}>
            <div className="chart-info-detail" style={{ cursor: "pointer" }}>
                <div className="index-title">
                    <span
                        className='index-name txt---500-12-18 txt-500'>
                        {nameFloor}
                    </span>

                    {' '}
                    <span className={"order-match " + "txt---400-12-18 txt-500"}
                    >

                        <span className={info.colorClass}>
                            {info.marketIndex || '-'}
                        </span>{' '}
                        <span
                            className={info.colorClass}
                        >{`(${info.changeValue ? (info.colorClass && info.colorClass === 'txt-lime' ? '+' + info.changeValue : info.changeValue) :
                            '0.00'} ${info.changePercent ? (info.colorClass && info.colorClass === 'txt-lime' ? '+' + info.changePercent : info.changePercent) : '0.00'}%)`}
                        </span>
                    </span>
                </div>
            </div>
            <div className={'chart-info-detail-price ' + "txt---400-11-18 txt-500"} >
                {defaultTheme == "dark" ? t('copytrade.common.increase') : t('copytrade.common.increase')}{' '}
                <span >{info.advance || 0}</span>{' '}
                {defaultTheme == "dark" ? 'noChange' : 'noChange'}{' '}
                <span >{info.noChange || 0}</span>{' '}
                {defaultTheme == "dark" ? t('copytrade.common.decrease') : t('copytrade.common.decrease')}{' '}
                <span >{info.decline || 0}</span>{' '}

            </div>
            <div className={"txt---400-11-18 txt-500"}>
                <span>{info.totalShareTradedInfo || '-'}</span>{' '}
                <span className="txt-orange">
                    {MarketInfoLabel(lang).shares}
                </span>{' - '}
                <span>{info.totalValueTradedInfo || '-'}</span>{' '}
                <span className="txt-orange">
                    {MarketInfoLabel(lang).bil}
                </span>{' - '}
                <span>{MarketInfoLabel(lang).statuses[info.statusKey] ||
                    '-'}</span>
            </div>
        </div>
    )
}

export default MarketIndexInfo